import { Component, OnInit } from '@angular/core';
import { Cxcmaegarante } from "../cxcinterfaces/cxcmaegarante";
import { CxcmaegaranteService } from "../cxcservicios/cxcmaegarante.service";
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { AuditoriagralService } from 'src/app/advantage/advantageservices/auditoriagral.service';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { Usuario } from 'src/app/usuario';

import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-cxcmaegarante',
  templateUrl: './cxcmaegarante.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class CxcmaegaranteComponent implements OnInit {
  barraBotones2: boolean;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;
  index: number;

  cxcgarante: Cxcmaegarante = {}
  /*tipo ID*/
  lblvalida: string = '';
  cmbide: any[];
  selectide: any;
  /* Nacionalidad */
  cmbNacio: any[] = [];
  valorNacio: any;
  /*Situación Laboral */
  cmbSitLab: any[] = []
  valorSitLab: any

  /*cheks*/
  chkbieninmueble: boolean;
  chkvehiculo: boolean;
  /*permisos*/
  permisocxcgarante: SegMaePermiso
  /*control nuevo*/
  boolnuevo: boolean;
  /*busqueda*/

  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;//CDPJ
  displayDialogBusquedaFast
  /*pin de carga*/
  spin
  bolgarante
  // autorizacion
  claveAuth: string;
  autorizacionCodigo: string;
  bolAutorizacion: boolean;
  displayDialogAutorizacion: boolean;
  /**almacenar documentos */
  displayDialogDocumentos = false;

  constructor(
    public cxcmaegaranteService: CxcmaegaranteService,
    private init: NuevoComponentService, private permisosService: PermisosService,
    private messageService: MessageService, private busqService: InvbusquedaService,
    private utilitariosService: UtilitariosService, private auditoriagral: AuditoriagralService,
    private datePipe: DatePipe,private confirmationService: ConfirmationService,
    private confIniciales: ConfInicialesService, public usuario: Usuario,
  ) { }

  async ngOnInit() {
    this.index = 0;
    this.barraBotones2 = true;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.boolnuevo = true;
    this.spin = false;
    this.bolgarante = true;

    this.valorNacio = { codigo: '', name: '' };
    this.valorSitLab = { codigo: '', name: '' };
    this.cmbide = [{ codigo: '1', name: 'R.U.C.' },
    { codigo: '2', name: 'Cédula' },
    { codigo: '3', name: 'Pasaporte' }];
    this.cxcgarante = {}
    await Promise.all([this.nacionalidad(), this.getPermisos(), this.sitlaboral()
    ])
  }
  async nacionalidad() {
    this.cxcmaegaranteService.busPAISRESI().subscribe(data => {
      this.cmbNacio = []
      this.cmbNacio.push({ codigo: '', name: '' });
      for (const rs of data) {
        this.cmbNacio.push({ codigo: rs.CODSRI_CODIGO, name: rs.CODSRI_DESCRIPCION });
      }
    });
  }
  async sitlaboral() {
    this.cxcmaegaranteService.busSitLab().subscribe(data => {
      this.cmbSitLab = []
      this.cmbSitLab.push({ codigo: '', name: '' });
      for (const rs of data) {
        this.cmbSitLab.push({ codigo: rs.REF_CODIGO, name: rs.REF_NOMBRE });
      }
    });
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(
        this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisocxcgarante = data[0];
        } else {
          this.permisocxcgarante = null;
        }
      } else {
        this.permisocxcgarante = null;
      }
      return data
    } catch (e) {
      this.permisocxcgarante = null;
      this.messageService.add({
        key: 'maegarante',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
 async manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisocxcgarante.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisocxcgarante.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'maegarante',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisocxcgarante.PERACTUALIZACION === 1) {
        this.spin = true;
        this.validarguardar();
      }
      if (this.permisocxcgarante.PERACTUALIZACION === 0) {
        this.messageService.add({
          key: 'maegarante',
          severity: 'error',
          summary: 'Actualización de Garante',
          detail: 'El usuario no tiene permisos de actualización, acción denegada'
        });
      }

    }
    if (valor === 'Borrar') {
      if (this.permisocxcgarante.PERTODO === 1) {
  
        this.borrar();
      } else {
        if (this.permisocxcgarante.PERELIMACION === 1) {
          this.borrar();
        } else {
          this.messageService.add({
            key: 'maegarante',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if (valor === 'Primero') {
      this.seleccionarRegistro('P');
    }
    if (valor === 'Anterior') {
      this.seleccionarRegistro('A');
    }
    if (valor === 'Siguiente') {
      this.seleccionarRegistro('S');
    }
    if (valor === 'Ultimo') {
      this.seleccionarRegistro('U');
    }
    if (valor === 'Buscar') {
      this.busquedaGarante();
    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Almacenardoc') {
      if (this.boolnuevo === false) {
        const usu = await this.confIniciales.obtenerPermisoUsuario(this.usuario.identificacion);
        if (usu[0].USU_ALMACENARDOC === 1 || usu[0].USU_VISUALIZARDOC === 1) {
          this.displayDialogDocumentos = true;
        } else {
          this.messageService.add({
            key: 'maegarante',
            severity: 'info',
            summary: 'Información',
            detail: 'No tiene los permisos necesarios. Consulte con el Administrador del Sistema'
          });
        }

      }
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el garante?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmmaegarante',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let numreg=0
          let garid=this.cxcgarante.GAR_ID
          const data = await this.cxcmaegaranteService.verificargarante(this.cxcgarante.GAR_ID)
          if (data !== null && Object.keys(data).length>0) {
            for (const iterator of data) {
              numreg=iterator.NUMERO
            }
          }
          if (numreg >0) {
            this.messageService.add({
              key: 'maegarante',
              severity: 'error',
              summary: 'Información',
              detail: 'no se puede eliminar el garante porque ya está registrado en una amortización'
            });
            return;
          }
          
          await this.cxcmaegaranteService.borrarRegistro(garid)
          this.cxcgarante.GAR_ID= ''
          await this.auditoriagral.registrarAuditoria('CXC_MAEGARANTE',
          this.cxcgarante.GAR_ID + '/Nombre:' + this.cxcgarante.GAR_NOMBRE, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'maegarante',
            severity: 'success',
            summary: 'Información',
            detail: 'El garante se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'maegarante',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error
          });
          console.log(error)
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async seleccionarRegistro(strTipo) {
    try {
      let codigo = isNullOrUndefined(this.cxcgarante.GAR_ID) ? '' : this.cxcgarante.GAR_ID
      const datos = await this.cxcmaegaranteService.seleccionarRegistroProm(strTipo, codigo);
      if (datos !== null) {
        if (datos.length > 0) {
          this.encontrargarante(datos[0].GAR_ID);
        }
      }

    } catch (error) {
      this.messageService.add({
        key: 'maegarante',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al seleccionar el garante ' + error
      });
    }
  }

  busquedaGarante() {
    this.opcionbusqueda = 'busquedagarante';
    this.types = [
      { label: 'RUC', value: 'GAR_ID' },
      { label: 'Nombre', value: 'GAR_NOMBRE' },
      // { label: 'RucIde', value: 'CLI_RUCIDE' },
      // { label: 'Zona', value: 'CLI_ZONA' },
      // { label: 'Grupo', value: 'GRU_CODIGO' },
      // { label: 'Contacto', value: 'CLI_CONTACTO' },
      // { label: 'Placa', value: 'CLI_PLACA' },
      // { label: 'NombreC', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'CXC_MAEGARANTE';
    this.where = ''
    this.busqService.busquedaCxcMaeGarante().subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.displayDialogBusquedaFast = true;
    });
  }
  async validarguardar() {
    let codigo=isNullOrUndefined(this.cxcgarante.GAR_ID)?'':this.cxcgarante.GAR_ID
    const data = await this.cxcmaegaranteService.getgarante(codigo);
    if (this.lblvalida === '' || this.lblvalida === 'Mal') {
      this.messageService.add({
        key: 'maegarante',
        severity: 'warn',
        summary: 'Información',
        detail: 'Identificación incorrecta'
      });
      this.spin = false
      return;
    }
    if (this.selectide.codigo === '2') {
      if ((this.cxcgarante.GAR_ID).toString().length > 10) {
        this.messageService.add({
          key: 'maegarante',
          severity: 'error',
          summary: 'Información',
          detail: 'El RUC / IDE, no puede ser mayor a 10 dígitos cuando es del tipo cédula'
        });
        this.spin = false
        return;
      }
    }
    if (this.cxcgarante.GAR_ID === '' ||
      this.cxcgarante.GAR_NOMBRE === '' ||
      this.cxcgarante.GAR_NACIONALIDAD === '' ||
      this.cxcgarante.GAR_FECNAC === '' ||
      this.cxcgarante.GAR_SEXO === '' ||
      this.cxcgarante.GAR_EDAD === '' ||
      this.cxcgarante.GAR_ESTCIVIL === '' ||
      this.cxcgarante.GAR_DIRECCION === '' ||
      this.cxcgarante.GAR_TELEFONO1 === '' ||
      this.cxcgarante.GAR_CORREO === '' ||
      this.cxcgarante.GAR_SITLAB === '' ||
      this.cxcgarante.GAR_INGMEN === '' ||
      this.cxcgarante.GAR_TIPOID === '') {
      this.messageService.add({
        key: 'maegarante',
        severity: 'warn',
        summary: 'Información',
        detail: 'Los campos RUC / IDE, Nombre, Tipo ID, Nacionalidad, Fecha Nacimiento, Sexo,,Edad,,Estado Civil, Dirección, ' +
          'Teléfono 1, Correo, Situación laboral, Ingresos Mensuales, Tipo ID' +
          ' son obligatorios revise que los datos sean validos'
      });
      this.spin = false
      return;
    }
    if (data !== null && Object.keys(data).length>0 && this.boolnuevo === true) {
      this.confirmactualizacion();
      return
    }
    this.finalguardar();
  }
  confirmactualizacion(){
    this.confirmationService.confirm({
      message: 'EL garante con número de identificación: '+this.cxcgarante.GAR_ID+', ya existe, desea actualizar los datos?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmmaegarante',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.boolnuevo = false
        this.finalguardar();
      },
      reject: () => {
        this.confirmationService.close();
        this.spin = false;
      }
    });
  }
  async finalguardar() {
    try {
      if (this.boolnuevo === true) {
        if (this.cxcgarante.GAR_FECNAC.toString().includes('-')) {
          this.cxcgarante.GAR_FECNAC = this.datePipe.transform(this.cxcgarante.GAR_FECNAC, 'dd/MM/yyyy')
        }
        if (this.chkbieninmueble === true) {
          this.cxcgarante.GAR_BIEINM = 'S'
        } else {
          this.cxcgarante.GAR_BIEINM = 'N'
        }
        if (this.chkvehiculo === true) {
          this.cxcgarante.GAR_VEHICULO = 'S'
        } else {
          this.cxcgarante.GAR_VEHICULO = 'N'
        }
        this.cxcgarante.GAR_NACIONALIDAD = this.valorNacio.codigo;

        this.cxcgarante.GAR_SITLAB = this.valorSitLab.codigo;

        this.cxcgarante.GAR_VALIDACION = this.lblvalida;

        await this.cxcmaegaranteService.insertargarante(this.cxcgarante)
        await this.auditoriagral.registrarAuditoria('CXC_MAEGARANTE', this.cxcgarante.GAR_ID, 'I',
          '', '01', '', '', '', '').toPromise();
        this.messageService.add({
          key: 'maegarante',
          severity: 'success',
          summary: 'Información',
          detail: 'Registro guardado con éxito'
        });
        this.boolnuevo = false;
        await this.cancelar();
      }
      if (this.boolnuevo === false) {
        if (this.cxcgarante.GAR_FECNAC.toString().includes('-')) {
          this.cxcgarante.GAR_FECNAC = this.datePipe.transform(this.cxcgarante.GAR_FECNAC, 'dd/MM/yyyy')
        }
        await this.cxcmaegaranteService.insertargarante(this.cxcgarante)
        await this.auditoriagral.registrarAuditoria('CXC_MAEGARANTE', this.cxcgarante.GAR_ID, 'A',
          '', '01', '', '', '', '').toPromise();
        this.messageService.add({
          key: 'maegarante',
          severity: 'success',
          summary: 'Información',
          detail: 'Registro guardado con éxito'
        });
        await this.cancelar();
      }
    } catch (error) {
      this.messageService.add({
        key: 'maegarante',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar el garante ' + error
      });
      this.spin = false
      console.log(error);
    }
  }
  async cancelar() {
    if (this.boolnuevo === true) {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      this.chkbieninmueble = false;
      this.chkvehiculo = false;
      this.lblvalida = ''
      this.spin = false
      this.valorNacio = { codigo: '', name: '' };
      this.valorSitLab = { codigo: '', name: '' };
      this.selectide = { codigo: this.cmbide[0].codigo, name: this.cmbide[0].name };
      this.cxcgarante = {}

      document.getElementById('contorno').style.pointerEvents = 'none';


    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      this.chkbieninmueble = false;
      this.chkvehiculo = false;
      this.lblvalida = ''
      this.valorNacio = { codigo: '', name: '' };
      this.valorSitLab = { codigo: '', name: '' };
      await this.encontrargarante(this.cxcgarante.GAR_ID)
    }
  }
  async encontrargarante(codigo) {
    try {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      this.cxcgarante = {}
      this.spin = true
      const data = await this.cxcmaegaranteService.getgarante(codigo);
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          this.boolnuevo = false
          iterator.GAR_FECNAC = new Date(iterator.GAR_FECNAC)
          this.chkbieninmueble = iterator.GAR_BIEINM === 'S'
          this.chkvehiculo = iterator.GAR_VEHICULO === 'S'
          this.lblvalida = iterator.GAR_VALIDACION;
          iterator.GAR_NUEVO = 'N'
          this.cxcgarante = iterator

          for (const j of this.cmbide) {
            if (this.cxcgarante.GAR_TIPOID === j.codigo) {
              this.cxcgarante.GAR_TIPOIDNOMBRE = j.name;
              this.selectide = { codigo: j.codigo, name: j.name };
            }
          }
          for (const j of this.cmbNacio) {
            if (this.cxcgarante.GAR_NACIONALIDAD === j.codigo) {
              this.cxcgarante.GAR_NACIONALIDADNOMBRE = j.name;
              this.valorNacio = { codigo: j.codigo, name: j.name };
            }
          }
          for (const j of this.cmbSitLab) {
            if (this.cxcgarante.GAR_SITLAB === j.codigo) {
              this.cxcgarante.GAR_SITLABNOMBRE = j.name;
              this.valorSitLab = { codigo: j.codigo, name: j.name };
            }
          }
          if (this.cxcgarante.GAR_SEXO !== null) {
            this.cxcmaegaranteService.erNombreSexo(this.cxcgarante.GAR_SEXO).subscribe(eR => {
              if (eR !== null) {
                if (eR[0] !== undefined) {
                  this.cxcgarante.GAR_SEXONOMBRE = eR[0].REF_NOMBRE;
                }
              }
            })
          }
          if (this.cxcgarante.GAR_ESTCIVIL !== null) {
            this.cxcmaegaranteService.erNombreEstadoCivil(this.cxcgarante.GAR_ESTCIVIL).subscribe(eR => {
              if (eR !== null) {
                if (eR[0] !== undefined) {
                  this.cxcgarante.GAR_ESTCIVNOMBRE = eR[0].REF_NOMBRE;
                }
              }
            })
          }
          this.boolnuevo = false
        }

        document.getElementById('contorno').style.pointerEvents = 'all';
        this.spin = false
      } else {
        this.spin = false
      }

    } catch (error) {
      this.messageService.add({
        key: 'maegarante',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar los datos del garante ' + error
      });
      this.spin = false
      return;
    }
  }
  async nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.boolnuevo = true;
    this.chkbieninmueble = false;
    this.chkvehiculo = false;
    this.bolgarante = true;

    this.cxcgarante = {
      COM_CODIGO: '01', GAR_BIEINM: '', GAR_BIEINMDES: '', GAR_CORCONY: '', GAR_COREMOTRA: '',
      GAR_CORREO: '', GAR_DIRCONY: '', GAR_DIRECCION: '', GAR_DIREMPTRA: '', GAR_EDAD: '',
      GAR_EMPTRA: '', GAR_ESTCIVIL: '', GAR_ESTCIVNOMBRE: '', GAR_FECNAC: new Date(), GAR_ID: '',
      GAR_IDCONYUGE: '', GAR_INGMEN: '', GAR_NACIONALIDAD: '', GAR_NOMBRE: '', GAR_NOMCONY: '',
      GAR_SEXO: '', GAR_SEXONOMBRE: '', GAR_SITLAB: '', GAR_TELCONY: '', GAR_TELEFONO1: '', GAR_TELEFONO2: '',
      GAR_TELEMPTRA: '', GAR_TIPOID: '1', GAR_VEHDES: '', GAR_VEHICULO: '', USU_IDENTIFICACION: '', GAR_NUEVO: 'S'
    }
    this.selectide = { codigo: this.cmbide[0].codigo, name: this.cmbide[0].name };
    this.valorNacio = { codigo: '', name: '' };
    this.valorSitLab = { codigo: '', name: '' };

    document.getElementById('contorno').style.pointerEvents = 'all';
    setTimeout(() => {
      document.getElementById('GAR_ID').focus();
    }, 100);
  }
  botmodclirucide() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.lblvalida = '';
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'GAR_ID': {
        element = document.getElementById('GAR_NOMBRE');
        break;
      }
      case 'GAR_NOMBRE': {
        element = document.getElementById('GAR_SEXO');
        break;
      }
      case 'GAR_SEXO': {
        this.busquedasexo(event.target.value);
        break;
      }
      case 'GAR_EDAD': {
        element = document.getElementById('GAR_ESTCIVIL');
        break;
      }
      case 'GAR_ESTCIVIL': {
        this.busquedaestciv(event.target.value);
        break;
      }

      case 'GAR_DIRECCION': {
        element = document.getElementById('GAR_TELEFONO1');
        break;
      }
      case 'GAR_TELEFONO1': {
        element = document.getElementById('GAR_TELEFONO2');
        break;
      }
      case 'GAR_TELEFONO2': {
        element = document.getElementById('GAR_CORREO');
        break;
      }
      case 'GAR_BIEINMDES': {
        element = document.getElementById('GAR_INGMEN');
        break;
      }
      case 'GAR_VEHDES': {
        element = document.getElementById('GAR_IDCONYUGE');
        break;
      }
      case 'GAR_IDCONYUGE': {
        element = document.getElementById('GAR_NOMCONY');
        break;
      }
      case 'GAR_NOMCONY': {
        element = document.getElementById('GAR_DIRCONY');
        break;
      }
      case 'GAR_DIRCONY': {
        element = document.getElementById('GAR_TELCONY');
        break;
      }
      case 'GAR_TELCONY': {
        element = document.getElementById('GAR_CORCONY');
        break;
      }
      case 'GAR_CORCONY': {
        element = document.getElementById('GAR_EMPTRA');
        break;
      }
      case 'GAR_EMPTRA': {
        element = document.getElementById('GAR_DIREMPTRA');
        break;
      }
      case 'GAR_DIREMPTRA': {
        element = document.getElementById('GAR_TELEMPTRA');
        break;
      }
      case 'GAR_TELEMPTRA': {
        element = document.getElementById('GAR_COREMOTRA');
        break;
      }
      default: {
        break;
      }
    }

    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  async validar(rucide) {
    this.spin = true;
    const data = await this.cxcmaegaranteService.getgarante(rucide);
    if (data !== null && Object.keys(data).length>0) {
      this.confirmationService.confirm({
        message: 'EL garante con número de identificación: '+this.cxcgarante.GAR_ID+', ya existe, desea consultar los datos?',
        header: 'Pregunta',
        icon: 'pi pi-exclamation-triangle',
        key: 'confirmmaegarante',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: () => {
          this.boolnuevo = false
          this.encontrargarante(rucide)
        },
        reject: () => {
          this.confirmationService.close();
          this.spin = false;
        }
      });
      return
    }
    this.validaEnviaRespuesta(this.selectide.name, rucide);
  }
  async validaEnviaRespuesta(rucIdeTipo, rucIde) {

    if (rucIdeTipo === 'R.U.C.') {
      const vria = await this.validaConsultaRespuesta(rucIde);

      if (vria === 1) {
        await this.validaColocarLabels(1);
      } else if (vria === 3) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'success',
          summary: 'Información',
          detail: 'RUC no se encuentra en nuestra base de datos, verifique' +
            ' en el portal del SRI.'
        });
        this.claveAuth = '';
        this.autorizacionCodigo = 'AUTRUCID';
        this.displayDialogAutorizacion = true;
        this.spin = false;
      } else if (vria === 4) {
        await this.obtenerDatosCliente(rucIde);
      } else {
        await this.validaColocarLabels(2);
        this.cxcgarante.GAR_ID = '';
      }

    }
    if (rucIdeTipo === 'Cédula') {
      const vria = await this.validaConsultaRespuesta(rucIde);

      if (vria == 1) {
        await this.validaColocarLabels(1);
      } else if (vria == 3) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'success',
          summary: 'Información',
          detail: 'RUC no se encuentra en nuestra base de datos, verifique' +
            ' en el portal del SRI.'
        });
        this.claveAuth = '';
        this.autorizacionCodigo = 'AUTRUCID';
        this.displayDialogAutorizacion = true;
        this.spin = false;
      } else if (vria === 4) {
        await this.obtenerDatosCliente(rucIde);
      } else {
        await this.validaColocarLabels(2);
        this.cxcgarante.GAR_ID = '';
      }
    }
    if (rucIdeTipo === 'Pasaporte') {

      if ((this.cxcgarante.GAR_ID).toString().length >= 14) {
        this.messageService.add({
          key: 'maegarante',
          severity: 'error',
          summary: 'Información',
          detail: 'El RUC / IDE, no puede ser mayor a 13 dígitos'
        });
        this.spin = false
        return;
      }

      await this.validaColocarLabels(4);
    }
    if (rucIdeTipo === 'Placa') {
      await this.validaColocarLabels(4);
    }
    if (rucIdeTipo === 'Extranjero') {
      await this.validaColocarLabels(4);
    }
    if (rucIdeTipo === 'Consumidor Final') {
      await this.validaColocarLabels(4);
    }
  }
  async validaConsultaRespuesta(rucIde) {

    let valRucIDe = 0;

    if (this.selectide.name === 'R.U.C.') {
      const resp = await this.utilitariosService.ValidaRucAutorizacion(rucIde);

      if (resp == 1) {
        valRucIDe = 1;
      } else {
        if (resp == 4) {
          valRucIDe = 4;
        } else if (resp == 3) {
          valRucIDe = 3;
        } else {
          valRucIDe = 0;
        }
      }
    }
    if (this.selectide.name === 'Cédula') {
      if (rucIde !== '9999999999') {
        const resp = await this.utilitariosService.ValidaCedulaAutorizacion(rucIde, 1);
        if (resp == 1) {
          valRucIDe = 1;
        } else {
          if (resp == 4) {
            valRucIDe = 4;
          } else if (resp == 3) {
            valRucIDe = 3;
          } else {
            valRucIDe = 0;
          }
        }
      } else {
        valRucIDe = 0;
      }
    }

    if (this.selectide.name === 'Pasaporte') {
      valRucIDe = 1;
    }
    if (this.selectide.name === 'Placa') {
      valRucIDe = 1;
    }
    if (this.selectide.name === 'Extranjero') {
      valRucIDe = 1;
    }
    if (this.selectide.name === 'Consumir Final') {
      valRucIDe = 1;
    }

    return valRucIDe;

  }

  async validaColocarLabels(tipo) {
    if (tipo === 1) {
      this.lblvalida = "Bien";
      document.getElementById('GAR_NOMBRE').focus();
    }
    if (tipo === 2) {
      this.lblvalida = "Mal";
    }

    if (tipo === 3) {
      this.lblvalida = "Autoriza";
      document.getElementById('GAR_NOMBRE').focus();
    }

    // PARA PASAPORTES
    if (tipo === 4) {
      this.lblvalida = "Bien";
      document.getElementById('GAR_NOMBRE').focus();
    }

    if (tipo === 6) {
      this.lblvalida = "SRI";
      document.getElementById('GAR_NOMBRE').focus();
    }

    let codcliente = '';
    console.log('this.bolcliente', this.bolgarante);

    if (this.bolgarante === true) {
      // const formsricom = await this.cliService.erExisteCliente(this.maecliente.CLI_RUCIDE, codcliente).toPromise();
      // if (formsricom[0] !== undefined) {
      //   if (Number(formsricom[0].COUNT) > 0) {
      //     this.messageService.add({
      //       key: 'cliente',
      //       severity: 'warn',
      //       summary: 'Información',
      //       detail: 'Cliente ya existe'
      //     });
      //     this.lblvalida = "Mal";
      //     this.maecliente.CLI_CODIGO = ''
      //     this.spin = false;
      //   } else {
      //     if (this.bolcliente === false) {
      //       this.maecliente.CLI_CODIGO = this.maecliente.CLI_RUCIDE;
      //     }
      //     if (this.bolcliente === false && this.CNECC === 1) {
      //       this.maecliente.CLI_CODIGO = '';
      //     }
      //   }
      // }
    }

    this.spin = false;
    //CDPJ

  }

  async obtenerDatosCliente(rucIde) {
    let r = null;

    try {
      r = await this.utilitariosService.getrucsri(rucIde);
    } catch  {
      this.spin = false;
    }
    // console.log(r);
    if (r != null) {
      this.cxcgarante.GAR_NOMBRE = r.RAZON_SOCIAL;
      // this.cxcgarante.CLI_NOMBREC = r.RAZON_SOCIAL.substr(0, 12);
      // this.cxcgarante.CLI_CONTACTO = r.NOMBRE_COMERCIAL === "null" ? "" : r.NOMBRE_COMERCIAL;
      // this.cxcgarante.CLI_OBSERVACION = r.TIPO_CONTRIBUYENTE + " - "
      //   + r.ESTADO_CONTRIBUYENTE + " - "
      //   + r.CLASE_CONTRIBUYENTE + " - " + r.OBLIGADO;
      this.auditoriagral.registrarAuditoria('VEN_MAECLIENTE', 'SRI/' + rucIde, 'I',
        '', '01', '', '', '', '').subscribe();
      //this.buscarCodigosProv(r);
      this.validaColocarLabels(6);
    }
    this.spin = false;
  }
  busqide() {
    this.cxcgarante.GAR_TIPOID = this.selectide.codigo;
    //this.cxcgarante.CLI_TIPOIDENOMBRE = this.selectide.name;
    this.cxcgarante.GAR_ID = '';
    this.botonesmodificar();
  }
  botonesmodificar() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
  }
  cambioOptionNac(event) {
    this.cxcgarante.GAR_NACIONALIDAD = this.valorNacio.codigo;
    this.botonesmodificar();
  }
  cambioOptionSitLab(event) {
    this.cxcgarante.GAR_SITLAB = this.valorSitLab.codigo;
    this.botonesmodificar();
  }
  cambiarFocoNac(evento) {

  }
  busquedasexo(parametro) {
    this.opcionbusqueda = 'busquedasexo';
    this.types = [
      { label: 'Código', value: 'REF_CODIGO' },
      { label: 'Nombre', value: 'REF_NOMBRE' }
    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'SACI_MAEREFERENCIA';
    this.where = ' REF_TIPO=\'SEX\' '

    this.cxcmaegaranteService.erNombreSexo(parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.cxcgarante.GAR_SEXO = parametro;
          this.cxcgarante.GAR_SEXONOMBRE = eR[0].REF_NOMBRE;
          // document.getElementById('VEN_CODIGO').focus();
        } else {
          this.busqService.busquedaSaciMaeReferencia6('REF_TIPO=\'SEX\'').subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.busqService.busquedaSaciMaeReferencia6('REF_TIPO=\'SEX\'').subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.displayDialogBusquedaFast = true;
        });
      }
    });

  }
  busquedaestciv(parametro) {
    this.opcionbusqueda = 'busquedaestciv';
    this.types = [
      { label: 'Código', value: 'REF_CODIGO' },
      { label: 'Nombre', value: 'REF_NOMBRE' }
    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'SACI_MAEREFERENCIA';
    this.where = ' REF_TIPO=\'ESTCIV\' '
    this.cxcmaegaranteService.erNombreEstadoCivil(parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.cxcgarante.GAR_ESTCIVIL = parametro;
          this.cxcgarante.GAR_ESTCIVNOMBRE = eR[0].REF_NOMBRE;
          document.getElementById('GAR_DIRECCION').focus();
        } else {
          this.busqService.busquedaSaciMaeReferencia6('REF_TIPO=\'ESTCIV\'').subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.busqService.busquedaSaciMaeReferencia6('REF_TIPO=\'ESTCIV\'').subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.displayDialogBusquedaFast = true;
        });
      }
    });

  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'busquedasexo') {
      this.cxcgarante.GAR_SEXO = opcion.REF_CODIGO;
      this.cxcgarante.GAR_SEXONOMBRE = opcion.REF_NOMBRE;

    }
    if (this.opcionbusqueda === 'busquedaestciv') {
      this.cxcgarante.GAR_ESTCIVIL = opcion.REF_CODIGO;
      this.cxcgarante.GAR_ESTCIVNOMBRE = opcion.REF_NOMBRE;
      document.getElementById('GAR_DIRECCION').focus();
    }
    if (this.opcionbusqueda === 'busquedagarante') {
      this.encontrargarante(opcion.GAR_ID)
    }
    this.displayDialogBusquedaFast = false
  }
  changeTabs() {

  }

  onHideAutorizacion() {
    if (this.bolAutorizacion === false) {
      if (this.autorizacionCodigo === 'AUTRUCID') {
        this.messageService.add({
          key: 'maegarante',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente'
            + ' la clave para ingresar el Ruc/Ide'
        });
        this.cxcgarante.GAR_ID = '';
        document.getElementById('CLI_RUCIDE').focus();
      }
    }
  }
  comprobarClave() {
    this.utilitariosService.obtenerClave(this.autorizacionCodigo).subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        this.accionesAutorizacion();
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }

  accionesAutorizacion() {
    if (this.autorizacionCodigo === 'AUTRUCID') {
      this.validaColocarLabels(3);
    }

    this.displayDialogAutorizacion = false;
  }
  recibirSenalesDocumentos(valor) {
    if (valor === true) {
      this.displayDialogDocumentos = false;
    }
  }
}
